//auth-middle
import type { Profile } from "~/types/profile";
import * as Sentry from "@sentry/nuxt";

export default defineNuxtPlugin(async (nuxtApp) => {
   const authStore = useAuthStore();
   const authToken = useCookie("session").value;
   // const validToken = authToken ? isTokenValid(authToken) : false;
   const { logInfo } = useDebugger();
   /**
    * Clear authentication state
    */

   const resetAuth = () => {
      authStore.clearAuth();
      useCookie("session").value = null;
      // Don't automatically redirect to login - let the middleware handle it
   };
   if (!authToken) {
      resetAuth();
      return;
   }

   const { getProfileMeta } = useProfile();

   try {
      const userData = await getProfileMeta();

      if (userData) {
         const profile = userData as Profile.MetaData;

         authStore.setAuth(profile, authToken);
         logInfo("User data loaded:", authStore.user);

         // UserProfileResource omits `id`, but the runtime payload often
         // still carries it; treat as optional via cast.
         const userId = (userData as { id?: number | string }).id;
         Sentry?.setUser({
            id: userId?.toString(),
            email: userData?.email,
            username: userData?.email,
         });
      }
   } catch (err: any) {
      const status = err?.statusCode || err?.response?.status || err?.status;
      // 401/403: catcher in 0.api.ts already cleared cookie + redirected. Bail.
      if (status === 401 || status === 403) return;
      // Transient (5xx, network, timeout, deploy window): keep cookie. The
      // client-side piniaPersist plugin will rehydrate auth from localStorage,
      // and the next navigation will retry the profile fetch.
      logInfo("Profile fetch failed transiently, deferring to rehydrate", err);
      Sentry?.captureException(err);
   }

   return;
});
